import type { FontFamilyModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useOptimisticModifierValue } from "@v2/features/modifiers/hooks/useOptimisticModifierValue";

import FontSelector from "./FontSelector";

interface FontModifierProps {
  onChange: (modifiers: FontFamilyModifierValue[]) => void;
}

const FontModifierComponent: React.FC<FontModifierProps> = ({ onChange }) => {
  const currentValue =
    useOptimisticModifierValue({
      modifierType: { type: "fontFamily", value: "" },
      extractor: (elementDesignation) => {
        return elementDesignation.element.styleOverrides?.fontFamily ?? null;
      },
    }) ?? null;

  const handleValueChange = (fontName: string) => {
    onChange([
      {
        type: "fontFamily" as const,
        value: fontName,
      },
    ]);
  };

  return (
    <div className="flex-1">
      <FontSelector
        fontFamily={currentValue}
        onSelect={handleValueChange}
        placeholder="Select a font"
      />
    </div>
  );
};

export default FontModifierComponent;
